module.exports = __webpack_public_path__ + "img/pizza.19738be2.jpg";